<nav #navbarCommon class="navbar navbar-expand-lg navbar-light fixed-top bg-white">
  <div class="container">
    <img [src]="'assets/logos/logo.png'" width="120px" height="100%" class="d-inline-block align-top" alt="">
    <div class="text-center justify-content-center">
      <a class="d-inline-block nav-item nav-link">
        <img src="assets/flags/es.png" height="20" class="d-inline-block align-top" (click)="changeLanguage('es')" alt="">
      </a>
      <a class="d-inline-block nav-item nav-link">
        <img src="assets/flags/en.png" height="20" class="d-inline-block align-top" (click)="changeLanguage('en')" alt="">
      </a>
    </div>
  </div>
</nav>

<div class="container mt-5 pt-5">
  <div class="row">
    <div class="col">
      <h1>{{ "remittance.privacy.title" | translate}} </h1>
      <p class="translate-new-line">{{ "remittance.privacy.title_message_1" | translate}}</p>
      <p class="translate-new-line">{{ "remittance.privacy.title_message_2" | translate}}</p>
      <p class="translate-new-line">{{ "remittance.privacy.title_message_3" | translate}}</p>
      <hr>
      <ol type="I">
        <li><p>{{ "remittance.privacy.information_collect_receive" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.information_collect_receive_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.why_collect_information" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.why_collect_information_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.how_collect_information" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.how_collect_information_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.information_shared" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.information_shared_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.access_to_your_information" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.access_to_your_information_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.data_retention" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.data_retention_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.confidentiality_security" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.confidentiality_security_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.choices_about_information" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.choices_about_information_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.unlawful_discrimination" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.unlawful_discrimination_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.third_party_sites" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.third_party_sites_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.changes_to_this_policy" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.changes_to_this_policy_message" | translate}}</p>
        </li>
        <li><p>{{ "remittance.privacy.contacting_intermex" | translate}}</p>
          <p class="translate-new-line">{{ "remittance.privacy.contacting_intermex_message" | translate}}</p>
        </li>

      </ol>


    </div>
  </div>
</div>
